/**
 * Validates API response with status code and data structure
 * @param {Object} response - The API response object
 * @param {string} endpoint - Endpoint name for logging
 * @returns {Object} - { isValid: boolean, data: any, error: string }
 */
export const validateResponse = (response, endpoint) => {
  // Check HTTP status
  if (!response || response.status < 200 || response.status >= 300) {
    return {
      isValid: false,
      data: null,
      error: `HTTP ${response?.status || "unknown"} from ${endpoint}`,
    };
  }

  // Check if data exists
  if (!response.data) {
    return {
      isValid: false,
      data: null,
      error: `No data in response from ${endpoint}`,
    };
  }

  return {
    isValid: true,
    data: response.data,
    error: null,
  };
};

/**
 * Validates array response
 * @param {Object} response - The API response object
 * @param {string} endpoint - Endpoint name for logging
 * @returns {Object} - { isValid: boolean, data: any[], error: string }
 */
export const validateArrayResponse = (response, endpoint) => {
  const validation = validateResponse(response, endpoint);

  if (!validation.isValid) return validation;

  if (!Array.isArray(validation.data)) {
    return {
      isValid: false,
      data: null,
      error: `Expected array, got ${typeof validation.data} from ${endpoint}`,
    };
  }

  return validation;
};
